<style scoped lang="less">
#layout{position: fixed; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: 10px; bottom: 12px;height: 240px; width: 380px; top: 50%;left: 50%;transform: translate(-50%, -50%);}
.title{width: 92%; height: 30px;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 30px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.ol-popup-closer:after {content: "✖";}
.popup-content {width: 370px;height: 40px; display: flex; justify-content: space-between;}
/deep/.el-input{width: 130px !important;}
/deep/.el-slider{width: 245px}
/deep/.el-input__inner{width: 130px !important; color: #fff;}
.demonstration{width: 120px;line-height: 40px; color: #23fffc;}
#drag{height: 90%; overflow: auto;}
</style>

<template>
  <div id="layout" v-show="flag" @mousedown="onMousedown" >
    <p class="title">
      <span>设置透明度</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div id="drag">
      <div class="popup-content" v-for="(layer, index) in layerTree" :key="index">
        <span class="demonstration">{{layer.namec}}</span>
        <el-slider :max=1 v-model="layer.opacity" :step="0.1"  show-input @change="setOpacity(layer.name, layer.opacity)" @mousedown.native="onPrevent"></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data()
  {
    return {
      value: 1,
      flag: false,
      layer: false,
      checkedNode: []
    }
  },
  computed:
  {
    checkNode()
    {
      return this.$store.state.checkNode
    },
    layerTree()
    {
      return this.checkedNode
    }
  },
  watch: {
    checkNode(val)
    {
      this.checkedNode = val
    },
    value(val)
    {
      this.setOpacity(this.layname, val)
    },
    flag()
    {
      // this.Drag()
    }
  },
  mounted()
  {
    // this.Drag()
  },
  methods:
  {
    //关闭插件
    closePul(show)
    {
      this.flag = show
    },
    //获取设置当前图层透明度
    setOpacity(layername, value)
    {
      window.map.getLayers().forEach(e =>
      {
        let Attribute = e.getProperties().namee
        if (Attribute && Attribute === layername)
        {
          //设置图层属性
          e.setOpacity(value)
          //获取图层属性双向绑定
          this.value = e.getOpacity()
          //表示已经打开对应图层
          this.layer = true
        }
      })
      if (!this.layer)
        return this.$message({message: '请先勾选图层', type: 'warning', customClass: 'mzindex'})
    },
    onPrevent(e)
    {
      e.stopPropagation()
    },

    //设置拖拽
    onMousedown(e)
    {
      if (this.slider)
        return
      var oipc = document.getElementById('layout')
      var isDrag = false//是否开始拖拽 false 不拖拽
      var disX, disY//图片相对于图片的位置
      //鼠标按下时
      function aaa(e)
      {
        isDrag = true
        oipc.style.cursor = 'move'
        e = e || window.event//兼容性写法
        //鼠标位置
        var x = e.clientX
        var y = e.clientY
        //鼠标相对于图片的位置
        disX = x - oipc.offsetLeft
        disY = y - oipc.offsetTop
      }
      aaa()
      //鼠标移动时
      document.addEventListener('mousemove', function(e)
      {
        if (!isDrag)
          return
        e = e || window.event//兼容性写法
        //鼠标位置
        var x = e.clientX
        var y = e.clientY
        //修改图片位置
        oipc.style.left = x - disX + 'px'
        oipc.style.top = y - disY + 'px'
      })

      //鼠标抬起时
      document.addEventListener('mouseup', function()
      {
        isDrag = false
        oipc.style.cursor = 'default'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/SetTransparent.vue